export class ApiRequestError extends Error {
  readonly status: number;
  readonly code?: string;
  readonly correlationId?: string;

  constructor(params: { status: number; message: string; code?: string; correlationId?: string }) {
    super(params.message);
    this.name = 'ApiRequestError';
    this.status = params.status;
    this.code = params.code;
    this.correlationId = params.correlationId;
  }
}
